<template>
    <div>
        <a v-touch:tap="show" @click.prevent="show" href="javascript:void(0)" :class="linkClass">
            <slot />
        </a>

        <portal v-if="showing" to="modals">
            <div :class="{ 'visible': showing }" class="navbar-search fixed top-0 left-0 right-0 opacity-0 invisible z-50" class2="absolute">
                <div v-on-clickaway="hide">
                    <form @submit.prevent="handleSearch" ref="form" action="/search" method="GET" class2="flex justify-center">
                        <div class="navbar-search-header bg-white flex items-center border-b">
                            <input v-model="query" ref="query" name="query" type="text" placeholder="Type and hit enter to search..." class="form-control" />

                            <button type="submit" class="focus:outline-none">
                                <i class="far fa-search fa-lg mr-3"></i>
                            </button>

                            <button v-touch:tap="hide" @click.prevent="hide" type="button" class="text-gray-600 hover:text-gray-700 ml-1 lg:ml-2 focus:outline-none">
                                <i class="far fa-times fa-lg"></i>
                            </button>
                        </div>
                    </form>

                    <!-- <div v-cloak v-if="query && query.length > 3" class="bg-white pt-4 pb-5 px-4 lg:pt-6 lg:pb-8 lg:px-6"> -->
                        <!-- <template v-if="filteredOptions && filteredOptions.length > 0">
                            <label class="text-xs font-medium uppercase leading-snug text-gray-600 mb-2 lg:mb-3 flex items-center">
                                {{ __('Search Suggestions') }}
                            </label>

                            <ul class="list-unstyled flex flex-col mb-0 lg:flex-row lg:flex-wrap" class2="flex-no-wrap">
                                <li v-for="suggestion in filteredOptions[0].data" :key="suggestion" class="mt-1 mb-0 lg:mb-2 lg:mt-0 lg:mr-2">
                                    <a @click.prevent="choseSuggestion($event, suggestion)" href="javascript:void(0)" class="block rounded text-blue-700 py-1 px-3 border-transparent lg:border-gray-300 lg:border lg:border-solid focus:bg-indigo-100 hover:bg-indigo-100 lg:focus:border-indigo-100 lg:hover:border-indigo-100 whitespace-no-wrap">
                                        {{ suggestion }}
                                    </a>
                                </li>
                            </ul>
                        </template> -->

                        <!-- <hr class="my-8 border-0">

                        <label class="text-xs font-medium uppercase leading-snug text-gray-600 mb-2 lg:mb-3 flex items-center">
                            {{ __('Recent Searches') }}
                        </label>

                        <ul class="list-unstyled flex flex-col mb-0 lg:flex-row">
                            <li class="mt-1 lg:mt-0 lg:mr-1">
                                <a href="javascript:void(0)" class="block rounded text-blue-700 py-1 px-3 border-transparent lg:border-gray-300 lg:border lg:border-solid focus:bg-indigo-100 hover:bg-indigo-100 lg:focus:border-indigo-100 lg:hover:border-indigo-100">
                                    animal crossing
                                </a>
                            </li>
                        </ul> -->
                    <!-- </div> -->
                </div>
            </div>
        </portal>
    </div>
</template>

<script>
import { VueAutosuggest } from 'vue-autosuggest';
import { mixin as clickaway } from 'vue-clickaway';

export default {
    mixins: [clickaway],

    components: {
        VueAutosuggest
    },

    props: [
        'query',
        'link-class'
    ],

    data: () => ({
        showing: false,
        backdrop: null,
        suggestions: [{
            data: {}
            // data: window.App.categories || {}
        }]
    }),

    created() {
        if (this.app && this.app.categories) {
            this.suggestions = [{
                data: this.app.categories || {}
            }];
        }

        this.createBg();
    },

    destroyed() {
        this.destroyBg();
    },

    mounted() {},

    computed: {
        filteredOptions() {
            if (
                this.query === null
             || this.query === ''
             || this.query.length < 3
            ) {
                return [{data: []}];
            }

            return [{
                data: this.suggestions[0].data.filter(option => {
                    return option.toLowerCase().indexOf(this.query.toLowerCase()) > -1;
                })
            }];
        }
    },

    methods: {
        choseSuggestion($event, suggestion) {
            this.query = suggestion;

            this.$nextTick(() => {
                this.$refs.form.submit();
            });
        },

        handleSearch($event) {
            this.trackRawEvent('search', {
                query : this.query
            });

            this.$refs.form.submit();
        },

        handleEscape($event) {
            $event.stopPropagation();

            if ($event.keyCode == 27) {
                this.hide($event);
            }
        },

        show($event) {
            // this.$emit('search-opened');

            document
                .querySelectorAll('.dropdown-menu.show')
                .forEach(e => e.classList.remove('show'));

            this.showing = true;

            if (this.mobile) {
                document.body.classList.add('overflow-hidden');
            }

            this.backdrop.classList.add('show');

            this.$nextTick(() => {
                this.$refs.query.focus();
            });
        },

        hide($event) {
            // this.$emit('search-closed');

            this.showing = false;

            if (this.mobile) {
                document.body.classList.remove('overflow-hidden');
            }

            this.backdrop.classList.remove('show');
        },

        createBg() {
            const backdrop = document.createElement('div');
            backdrop.classList = 'backdrop invisible opacity-0 fixed top-0 left-0 w-screen h-screen z-10 transition-all duration-500';
            backdrop.style.cssText = 'background-color: rgba(15,21,32,.7);';

            this.backdrop = backdrop;

            document.body.appendChild(this.backdrop);
        },

        destroyBg() {
            document.body.removeChild(this.backdrop);
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
